import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const { init, fetching } = createAllActions(types.SCOPE);

const fetchData = () => ({
  type: types.FETCH_DATA,
});

const drilldown = params => ({
  type: types.DRILLDOWN,
  params,
});

export {
  init, fetching, fetchData, drilldown,
};
